<template lang="pug">
  include ../../../pug/mixins/bem

  +b.modal().is-opened
    +e.A.close(
      href!='', 
      @click.prevent='$emit("close")', 
    ) &times;
    +e.inner
      +e.header
        +e.title {{ _("Заполните контактную информацию") }}
      +e.content
        form(
          name="enter", 
          @submit.prevent='submit', 
          method='post', 
        )
          .modal__enter
            
            input-group(
              type="text"
              id='username'
              v-if='!user_email'
              name='username'
              :placeholder='_("Введите адрес электронной почты")'
              v-validate="'required|min:2|max:50|email'"
              v-model="form.username"
            )
            input-group(
              type="text"
              id='phone'
              ref='phone'
              v-if='!user_phone'
              name='phone'
              :placeholder='_("Введите номер телефона")'
              v-validate="'required|phone'"
              v-model="form.phone"
            )
            div(
              style='color: #dd4400', 
              v-if='errors.username'
            ): small(
              v-for='error in errors.username', 
              v-text='error'
            )
            .modal__form-bottom
              button.calendar__link.modal__submit(type="submit") {{ _('Сохранить') }}
              
</template>

<script>
import { mapActions } from 'vuex'

import InputGroup from "./InputGroup"
import { masking } from '@shared/utils/helpers'
import { default as Api } from '../services/Api'

export default {
  name: 'PersonalData',
  components: {
    InputGroup
  },
  data() {
    return { 
      form: {
        username: '',
        phone: ''
      },
      user_email: window.user_email,
      user_phone: window.user_phone,
    }
  },
  async mounted() {
    masking('phone', this)
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.load = true
          let formdata = {}
          Object.keys(this.form).forEach( key => {
            if (this.form[key]) {
              formdata[key] = this.form[key]

            }
          })
          Api().patch(window.user_update_url, formdata)
            .then(res => {
              this.load = false
              this.$emit('close')
              this.$validator.reset()
              this.form.email = ''
              // window.location.reload()
            }, err => {
              this.load = false
              this.$emit('close')
            })
        }
      })
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/PersonalData.vue